import React, { useState } from 'react';
import { ArrowRightOutlined, BankOutlined, GlobalOutlined, HomeOutlined, LoadingOutlined, StarFilled } from '@ant-design/icons';
import { BASE_URL, ID } from '../../constants/Config';

const CardSelector = ({ Entity, SelectEntity, type, disabled, isSelected }) => {
  const [imageError, setImageError] = useState(false);
  const [logoUrl] = useState(
    () => type === 2 ? null : `${BASE_URL}/api/Companies/GetLogo?Company_ID=${Entity.id}&Random=${ID()}`
  );
  const displayName = type === 2 ? Entity.displayBranch : Entity.displayCompany;
  const initials = (displayName || 'TG')
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map(word => word[0])
    .join('')
    .toUpperCase();

  return (
    <button
      type="button"
      className={`dasi-company-card${isSelected ? ' is-selected' : ''}`}
      disabled={disabled}
      onClick={() => SelectEntity(Entity)}
      aria-label={`Seleccionar ${displayName}`}>
      <span className="dasi-company-card__logo">
        {type === 2 ? (
          <BankOutlined aria-hidden="true" />
        ) : imageError ? (
          <span aria-hidden="true">{initials}</span>
        ) : (
          <img
            alt={`Logo de ${displayName}`}
            src={logoUrl}
            onError={() => setImageError(true)}
          />
        )}
      </span>

      <span className="dasi-company-card__body">
        <strong title={displayName}>{displayName}</strong>
        <span className="dasi-company-card__meta">
          {type === 2 ? <BankOutlined /> : Entity.isLocal ? <HomeOutlined /> : <GlobalOutlined />}
          {type === 2 ? 'Sucursal' : Entity.isLocal ? 'Nacional' : 'Internacional'}
        </span>
        {isSelected ? (
          <small><LoadingOutlined /> Abriendo compañía…</small>
        ) : Entity.isConsolidated === true ? (
          <small><StarFilled /> Compañía consolidada</small>
        ) : null}
      </span>

      <span className="dasi-company-card__action" aria-hidden="true">
        {isSelected ? <LoadingOutlined /> : <ArrowRightOutlined />}
      </span>
    </button>
  );
};

export default CardSelector;
